<template>
  <section>
    <div>
      <NavigationBar />
      <div
        class="uk-section uk-padding-remove-top uk-margin-top"
        v-if="!loading"
      >
        <!-- DESKTOP -->
        <div class="uk-visible@s uk-container uk-margin-top uk-margin-large-left uk-margin-large-right">
          <h3 class="uk-text-center uk-text-bold">Blog</h3>
          <div class="uk-margin-top ">
            <div class="uk-grid uk-grid-match" uk-grid>
              <div
                class="uk-width-1-3@s"
                v-for="(item, index) in blog"
                :key="index"
              >
                <div class="uk-card uk-card-default" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
                  <div class="uk-card-media-top">
                      <img :src="item.image" width="1800" height="1200" alt="">
                  </div>
                  <div class="uk-card-body uk-padding-remove">
                    <div class="uk-margin-top uk-margin-bottom uk-margin-left uk-margin-right">
                      <!-- <h3 class="uk-card-title">{{ item.title | truncate(50) }}</h3> -->
                      <h3 class="uk-card-title">{{ item.title }}</h3>
                      <p class="uk-margin-remove">{{ item.media }}</p>
                      <p class="uk-margin-remove uk-text-small uk-text-muted">{{ item.date }}</p>
                      <button @click="goTo(item.url)" class="uk-button uk-button-primary uk-text-capitalize uk-margin-small-top">Read More</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MOBILE -->
        <div class="uk-hidden@s uk-container uk-margin-top">
          <h3 class="uk-text-center uk-text-bold">Blog</h3>
          <div class="uk-margin-top ">
            <div class="uk-grid uk-grid-match" uk-grid>
              <div
                class="uk-width-1-3@s"
                v-for="(item, index) in blog"
                :key="index"
              >
                <div class="uk-card uk-card-default" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
                  <div class="uk-card-media-top">
                      <img :src="item.image" width="1800" height="1200" alt="">
                  </div>
                  <div class="uk-card-body uk-padding-remove">
                    <div class="uk-margin-top uk-margin-bottom uk-margin-left uk-margin-right">
                      <h3 class="uk-card-title">{{ item.title }}</h3>
                      <p class="uk-margin-remove">{{ item.media }}</p>
                      <p class="uk-margin-remove uk-text-small uk-text-muted">{{ item.date }}</p>
                      <button @click="goTo(item.url)" class="uk-button uk-button-primary uk-text-capitalize uk-margin-small-top">Read More</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="uk-section" style="height: 70vh">
        <div class="uk-container" style="height: 100%">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
      <h1 class="uk-heading-divider"></h1>
      <Footer />
    </div>
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    NavigationBar,
    Footer,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 960;
    },
  },
  data() {
    return {
      loading: false,
      blog : [
        {
          title: 'CubMu Kini Hadir di ROOMI Smart TV & ROOMI OTT Box',
          media: 'CNBC Indonesia',
          date: '26 June 2023 WIB',
          image: require('../assets/blog/press-released.jpeg'),
          url: 'https://www.cnbcindonesia.com/lifestyle/20230626125016-33-449273/cubmu-kini-hadir-di-roomi-smart-tv-roomi-ott-box'
        },
        {
          title: 'Kolaborasi CubMu dan Roomi Sajikan Konten Premium di Smart TV dan OTT Box',
          media: 'Insertlive',
          date: '24 June 2023 WIB',
          image: require('../assets/blog/press-released-2.jpeg'),
          url: 'https://www.insertlive.com/lifestyle/20230624030117-210-312982/kolaborasi-cubmu-dan-roomi-sajikan-konten-premium-di-smart-tv-dan-ott-box'
        },
        {
          title: 'Asyik! CubMu Kini Hadir di Roomi Smart TV dan OTT Box',
          media: 'Detikcom',
          date: '23 June 2023 WIB',
          image: require('../assets/blog/press-released.jpeg'),
          url: 'https://inet.detik.com/mobile-apps/d-6789491/asyik-cubmu-kini-hadir-di-roomi-smart-tv-dan-ott-box'
        },
        {
          title: 'CubMu Gandeng ROOMI Smart TV dan ROOMI OTT Box demi Sajikan Pengalaman Menikmati Hiburan Tercanggih',
          media: 'CXO Media',
          date: '26 June 2023 WIB',
          image: require('../assets/blog/press-released.jpeg'),
          url: 'https://www.cxomedia.id/general-knowledge/20230626173843-55-178993/cubmu-gandeng-roomi-smart-tv-dan-roomi-ott-box-demi-sajikan-pengalaman-menikmati-hiburan-tercanggih'
        }
      ]
    };
  },
  mounted() {
  },
  methods: {
    goTo(url){
      window.open(url, '_blank');
    }
  },
  filters: {
    truncate(text, length) {
      return text.substring(0, length) + '...'
    }
  }
};
</script>

<style lang="less" scoped>
@import "../custom/custom.less";

</style>